import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Row, OverlayTrigger, Popover } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import "./retirementtaxfreecash.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import DateFields from "../../atoms/DateFields";
import dayjs from "dayjs";
import { addCommas, formatGBP } from "../../helpers/helpers";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/actions";

export const RetirementTaxFreeCash = (props) => {
  const { choose } = useSelector(
    (state) => state.retirementApplication, // eslint-disable-line
  );
  const [lumpSumDetails, setLumpSumDetails] = useState(false);
  const [regularIncomeDetails, setRegularIncomeDetails] = useState(false);
  const [value, setValue] = useState("");
  const [regularValue, setRegularValue] = useState(0);
  const [sliderValue, setSliderValue] = useState(0);
  const [untilDate, setUntilDate] = useState(null);
  const [dateCheck, setDateCheck] = useState(false);
  const [dateCheckTwo, setDateCheckTwo] = useState(false);
  const [displayValue, setDisplayValue] = useState("");
  const [isDateError, setIsDateError] = useState(false);
  const detailsData = JSON.parse(localStorage.getItem("choose"));
  const sliderRef = useRef(null);
  const dispatch = useDispatch();

  const { retirementChoiceSubStepHandler } = bindActionCreators(
    actionCreators,
    dispatch // eslint-disable-line
  );

  const totalCash =
    Object.keys(choose).length === 0
      ? detailsData?.monetaryChosenAmount
      : choose?.monetaryChosenAmount; // eslint-disable-line
  const currentDate = new Date();
  let todayDate = dayjs(currentDate).format("DD/MM/YYYY");

  const handleClick = () => {
    setLumpSumDetails(true);
    setRegularIncomeDetails(false);

    setDateCheck(false);
    setDateCheckTwo(false);
  };
  const handleClickOne = () => {
    setLumpSumDetails(false);
    setRegularIncomeDetails(true);
  };

  const untilDateChange = (value) => {
    const inputDate = dayjs(value);
    const today = dayjs();
    const hundredYearsLater = today.add(100, "year");

    const formattedDate = inputDate.format("DD/MM/YYYY");
    const myDate = formattedDate.replace(/\//g, "-");

    if (!inputDate.isValid() || myDate === "Invalid Date") {
      setIsDateError(true);
    } else if (inputDate.isBefore(today, "day")) {
      setIsDateError(true); // Past date
    } else if (inputDate.isAfter(hundredYearsLater, "day")) {
      setIsDateError(true); // More than 100 years in future
    } else {
      setIsDateError(false);
    }

    setUntilDate(value);
  };

  const date = new Date(untilDate);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();

  const formattedDate = `${day}-${month}-${year}`;

  const handleSliderChange = (e) => {
    const percentage = parseFloat(e.target.value);
    setSliderValue(percentage);
    const value = (percentage / 100) * totalCash;
    setValue(parseFloat(value).toFixed(2));
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value.replace("%", "");
    if (inputValue === "") {
      setSliderValue("0");
      setValue("0");
    } else {
      const percentage = parseFloat(inputValue);
      if (!isNaN(percentage) && percentage >= 0 && percentage <= 25) {
        setSliderValue(percentage);
        const value = (percentage / 100) * totalCash;
        setValue(parseFloat(value).toFixed(2));
      }
    }
  };

  useEffect(() => {
    updateSliderBackground(sliderValue);
  }, [sliderValue, lumpSumDetails]);

  const updateSliderBackground = (value) => {
    const percentage = (value / 25) * 100;
    if (sliderRef.current) {
      sliderRef.current.style.background = `linear-gradient(to right, var(--blue-100) 0%, var(--blue-100) ${percentage}%, var(--white) ${percentage}%, var(--white) 100%)`;
    }
  };

  const handleChange = (e) => {
    let input = e.target.value.replace(/[£,]/g, "").trim();
    // Allow typing a dot but don't store it unless followed by digits

    const TWO_DECIMAL_REGEX = /^\d*\.?\d{0,2}$/;

    if (TWO_DECIMAL_REGEX.test(input) && Number(input) <= totalCash * 0.25) {
      const numericValue = Number(input);

      setDisplayValue(input);

      if (numericValue <= 0) {
        setRegularValue("");
      } else {
        // Remove trailing dot if present
        const cleanValue = input.endsWith(".") ? input.slice(0, -1) : input;
        setRegularValue(cleanValue);
      }
    }
  };

  const checkBoxData = [
    {
      id: 1,
      checkboxName: "frequency",
      label: "Monthly",
      value: "MONTHLY",
      flag: true,
    },
    {
      id: 2,
      checkboxName: "frequency",
      label: "Quarterly",
      value: "QUARTERLY",
      flag: false,
    },

    {
      id: 3,
      checkboxName: "frequency",
      label: "6-monthly",
      value: "SIX_MONTHS",
      flag: false,
    },
    {
      id: 4,
      checkboxName: "frequency",
      label: "Once a year",
      value: "YEARLY",
      flag: false,
    },
  ];
  const [frequencyValue, setFrequencyValue] = useState(checkBoxData[0]?.value);
  const frequency = (item) => {
    setFrequencyValue(item.value);
    checkBoxData.forEach((obj) => {
      if (obj.id === item.id) {
        obj.flag = !obj.flag;
      } else {
        obj.flag = false;
      }
    });
  };
  const handleBack = () => {
    props.makeInitialStepper(false, 33, { isRetirementChoice: true }, true);
  };
  const isActiveMember = props?.isActiveMember;

  const handleContinue = () => {
    let currentStep = RA_STEPS_IDENTIFIERS.RA_TAX_FREE_CASH;
    let taxFreeCash = {
      active: true,
      isRegularincome: regularIncomeDetails,
      regularIncomeFrequency: regularIncomeDetails ? frequencyValue : "",
      regularIncomePayment: regularValue ? parseFloat(regularValue) : 0,
      regularIncomePensionLastDate: lumpSumDetails
        ? ""
        : dateCheck
          ? formattedDate
          : "Until further notice",
      islumpSum: lumpSumDetails,
      percenateLumpsum: sliderValue ? sliderValue : 0,
    };
    let payload = {
      currentStep,
      choiceCategory: { taxFreeCash },
    };
    localStorage.setItem("taxFreeCash", JSON.stringify(taxFreeCash));
    retirementChoiceSubStepHandler({
      isInvestRest: true,
      activeUser: isActiveMember,
      asLumpSum: lumpSumDetails,
    });
    props.nextStepIndentifier(RA_STEPS_IDENTIFIERS.RA_TAX_FREE_CASH, payload);
  };
  return (
    <>
      <Card className="application-step">
        <Card.Body className="tax-free-cash">
          <h2 className="heading">
            How would you like to take your tax-free cash?
          </h2>
          <p>
            You can take some or all of your{" "}
            <span className="bold-text">25% tax-free cash</span> and invest the
            related taxable portion of your pension savings in a TPT drawdown
            account.
          </p>
          <p>
            You can even use your tax-free cash to provide regular income,
            moving the related taxable pension savings into a TPT drawdown
            account, each time you receive income.
          </p>
          <p>
            Remember that for every <span className="bold-text">£1</span> of
            tax-free cash you take, we&apos;ll move{" "}
            <span className="bold-text">£3</span> into your drawdown account,
            where you can keep it invested until you need it.
          </p>
          <Row className="small-card-section">
            <Col md={6}>
              <Card className={lumpSumDetails ? "bg-turquoise" : "bg-white"}>
                <Card.Body className="fixed-box">
                  <h3 className="subHeading">
                    <Icons
                      iconname="icons-find-pension"
                      variant="icon-fourty-eight-px"
                    />
                    As a lump sum
                  </h3>
                  <p>
                    I want to take a tax-free lump sum and move my taxable
                    savings to a TPT drawdown account
                  </p>
                  <p className="select-btn">
                    <Buttons
                      handleClick={handleClick}
                      className="tertiary "
                      name={lumpSumDetails == true ? "Selected" : "Select"}
                    />
                  </p>
                  <div className={lumpSumDetails ? "triangle-down" : ""}>
                    <span></span>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card
                className={regularIncomeDetails ? "bg-turquoise" : "bg-white"}
              >
                <Card.Body className="fixed-box">
                  <h3 className="subHeading">
                    <Icons
                      iconname="icons-moderate"
                      variant="icon-fourty-eight-px"
                    />
                    As regular income
                  </h3>
                  <p>
                    I want to take my tax-free cash as regular income, and move
                    the related taxable pension savings (£3 for every £1 of
                    tax-free savings) into a TPT drawdown account
                  </p>
                  <p className="select-btn">
                    <Buttons
                      handleClick={handleClickOne}
                      className="tertiary "
                      name={
                        regularIncomeDetails == true ? "Selected" : "Select"
                      }
                    />
                  </p>
                  <div className={regularIncomeDetails ? "triangle-down" : ""}>
                    <span></span>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {lumpSumDetails && (
            <Card className="bottom-bg-card">
              <Card.Body>
                <Row className="bottom-card-content">
                  <Col md={6}>
                    <p>
                      {" "}
                      Select the tax-free cash lump sum you wish to take (up to
                      25%) by entering the percentage or using the slider.
                    </p>
                    <p className="form-field taking-cash">
                      <span>Taking as cash</span>
                      <input
                        type="text"
                        className="input-text"
                        value={`${sliderValue}%`}
                        onChange={handleInputChange}
                        min="0"
                        max="100"
                      />
                    </p>
                  </Col>
                  <Col md={6}>
                    <Row>
                      <Col md={8} className="text-left">
                        <p>Applying with</p>
                        <p>Taking as tax-free cash</p>
                        <p>Moving to drawdown</p>
                      </Col>
                      <Col md={4} className="text-right bld p-0">
                        <p>{"£" + addCommas(totalCash.toFixed(2))}</p>
                        <p>
                          {"£" +
                            addCommas(
                              (totalCash * (sliderValue / 100)).toFixed(2) // eslint-disable-line
                            )}
                        </p>
                        <p className="moving-to-drawdown">
                          {"£" +
                            addCommas(
                              (totalCash * (sliderValue / 100) * 3).toFixed(2) //eslint-disable-line
                            )}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <div>
                  <p className="slider-value">
                    <span className="static">0%</span>
                    <span className="static text-right">25%</span>
                  </p>
                  <Form.Range
                    ref={sliderRef}
                    value={sliderValue}
                    min="0"
                    max="25"
                    className="custom-slider"
                    onChange={handleSliderChange}
                  />
                </div>
                <div className=" m-42 d-flex align-items-center">
                  <div className="value-correct-date">
                    {" "}
                    Values correct as of {todayDate}
                  </div>
                  <OverlayTrigger
                    placement="left"
                    overlay={
                      <Popover
                        id="popover-contained"
                        className="tooltip-popover-section custom-popover"
                      >
                        <Popover.Body className="tooltip-popover-body-how-much-cash">
                          <p>
                            {" "}
                            All the values are estimates, based on the most
                            accurate information available. They include all the
                            contributions paid by you and your employer.
                          </p>
                          <p>
                            The value of your pension savings is based on
                            current financial conditions and is not guaranteed.
                            The amounts you receive may be higher or lower than
                            the amounts shown above. Payment of your pension
                            will be subject to TPT’s Trust Deed and Rules, and
                            regulatory requirements.
                          </p>{" "}
                        </Popover.Body>
                      </Popover>
                    }
                    flip={true}
                  >
                    <span className="textarea-tooltip">
                      <Icons iconname="tool-tip" variant="icon-twelve-px" />
                    </span>
                  </OverlayTrigger>
                </div>
              </Card.Body>
            </Card>
          )}

          {regularIncomeDetails && (
            <Card className="bottom-bg-card">
              <Card.Body>
                <Row className="bottom-card-content">
                  <Col md={12}>
                    <p className="bold-heading">
                      How frequently would you like to receive your tax-free
                      cash as income?
                    </p>
                    <div className="check-box">
                      {checkBoxData?.map((item, index) => {
                        return (
                          <span key={index}>
                            <CustomCheckbox
                              name="Check"
                              label={item.label}
                              variantName="custom-checkbox mt-3"
                              defaultChecked={item.flag}
                              onChange={() => frequency(item)}
                            />
                          </span>
                        );
                      })}
                    </div>
                    <p className="bold-heading mt-3">
                      How much would like to receive for each payment?
                    </p>
                    <p className="mt-3 mb-4">
                      <input
                        type="text"
                        value={formatGBP(displayValue)}
                        id="amount"
                        min="0"
                        max={totalCash * 0.25}
                        aria-describedby="amount"
                        onChange={handleChange}
                        className="gbp-input"
                      />
                    </p>
                    <p>
                      Payments are on the anniversary of your initial payment,
                      e.g. if a first payment was 5th June then a 6-monthly
                      payment would next be paid on 5th December.
                    </p>
                    <p>
                      Moving to drawdown:
                      <span className="bold-heading">
                        {" £" + addCommas((regularValue * 3).toFixed(2))}
                      </span>{" "}
                    </p>
                    <div className="check-box-btm">
                      <Row className="first-declare-parent">
                        <Col className="check-text dafield">
                          <CustomCheckbox
                            name="paymentUntilDate"
                            type="radio"
                            variantName="custom-checkbox mt-3"
                            onChange={() => {
                              setDateCheck(true);
                              setDateCheckTwo(false);
                            }}
                            label={
                              <span>
                                I want my payments to continue until
                                <DateFields
                                  value={untilDate}
                                  plainDateField={true}
                                  onChange={untilDateChange}
                                  error={isDateError}
                                />
                                (or until my tax-free cash runs out, whichever
                                is sooner).
                              </span>
                            }
                          />
                        </Col>
                      </Row>

                      <CustomCheckbox
                        name="paymentUntilDate"
                        type="radio"
                        variantName="custom-checkbox mt-3"
                        label={
                          "I want my payments to continue until further notice, or until my tax-free cash runs out, whichever is sooner."
                        }
                        onChange={() => {
                          setDateCheckTwo(true);
                          setDateCheck(false);
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}
          <Row className="button-container mt-4">
            <Col md={6}>
              {" "}
              <Buttons
                handleClick={handleBack}
                className="secondary back-btn"
                name="Back"
              />
            </Col>
            <Col md={6} className="text-end">
              <Buttons
                handleClick={() => handleContinue()}
                className="primary"
                name="Continue"
                disabled={
                  !(
                    (lumpSumDetails === true && parseFloat(value) > 0) ||
                    (regularIncomeDetails === true &&
                      regularValue > 0 &&
                      dateCheck === true &&
                      untilDate !== null &&
                      !isDateError) ||
                    (regularIncomeDetails === true &&
                      regularValue > 0 &&
                      dateCheckTwo === true)
                  )
                }
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};
export default RetirementTaxFreeCash;
